import React from 'react';

import { Icon } from '@rbilabs/components-library';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { ClickableContainer } from 'components/clickable-container';
import { primitive } from 'styles/constants/primitives';

const ContainerNoDecoration = styled(ClickableContainer)`
  margin: ${primitive.$spacing3} ${primitive.$spacing6};
  position: fixed;
  border-radius: 100%;
  z-index: ${Styles.zIndex.overlay};
  top: calc(3px + env(safe-area-inset-top));
  left: 3px;
  ::before {
    color: transparent;
  }
  &:active,
  &:focus {
    background-color: ${p => p.theme.token('background-icon-header-contrast')};
  }
  &:hover,
  &:link,
  &:visited {
    color: inherit;
  }
`;

const LinkNoDecoration = styled(Link)`
  margin: ${primitive.$spacing3} ${primitive.$spacing6};
  position: fixed;
  border-radius: 100%;
  z-index: ${Styles.zIndex.overlay};
  top: calc(3px + env(safe-area-inset-top));
  left: 3px;
  ::before {
    color: transparent;
  }
  &:active,
  &:focus {
    background-color: ${p => p.theme.token('background-icon-header-contrast')};
  }
  &:hover,
  &:link,
  &:visited {
    color: inherit;
  }
`;

export const BackArrowLink = ({ to }: { to: string }) => {
  return (
    <LinkNoDecoration to={to}>
      <Icon icon="back" color="icon-header-contrast" width="24px" aria-hidden />
    </LinkNoDecoration>
  );
};

export const BackArrowHistory = () => {
  return (
    <ContainerNoDecoration data-testid="back-arrow-history" onClick={() => window.history.back()}>
      <Icon icon="back" color="icon-header-contrast" width="24px" aria-hidden />
    </ContainerNoDecoration>
  );
};
